<label class="label label-sm-single" [class.disabled]="isLoading | async">{{ 'newsFeedWidget.header.sourceFilter' | translate }}</label>
<!--
  If minimal is selected ensure that selector class is set else insert inline-dropdown class
-->
<ng-select
  #selectMultiple
  class="ui2-dropdown  {{ useMinimal ? 'minimal ' + selectorClass ?? 'inline-dropdown' : '' }}"
  dropdownPosition="bottom"
  bindLabel="key"
  [clearable]="true"
  [searchable]="true"
  [editableSearchTerm]="''"
  [items]="sources"
  [placeholder]="
    useMinimal ? (model ? (model.length > 0 ? (model.length | formatNumber) : '') : '') : ('newsFeedWidget.header.all' | translate)
  "
  [(ngModel)]="model"
  [multiple]="true"
  [closeOnSelect]="false"
  [compareWith]="compareWith"
  [loading]="isLoading | async"
  [disabled]="isLoading | async"
  (add)="onChange()"
  (remove)="onChange()"
  (close)="onClose()"
  (clear)="triggerUpdate()"
>
  <ng-template *ngIf="!useMinimal" ng-label-tmp let-item="item">
    <ui2-dropdown-label-multiple bindLabel="key" [model]="model"> </ui2-dropdown-label-multiple>
  </ng-template>

  <ng-template *ngIf="useMinimal" ng-label-tmp let-item="item">
    <span *ngIf="(isLoading | async) === false" class="item-count">({{ model.length }})</span>
  </ng-template>

  <ng-template ng-header-tmp>
    <ui2-dropdown-search-bar [select]="selectMultiple"> </ui2-dropdown-search-bar>
    <ui2-dropdown-bulk-functions-bar [select]="selectMultiple" (onDeselectAll)="onChange()" (onDeselectFound)="removeFromList($event)">
    </ui2-dropdown-bulk-functions-bar>
  </ng-template>

  <ng-template ng-option-tmp let-item="item" let-index="index">
    <ui2-dropdown-option-multi-select bindLabel="key" bindValue="key" [item]="item" [model]="model">
      <ng-container *ngIf="item.doc_count">
        {{ item.doc_count | formatNumber }}
      </ng-container>
    </ui2-dropdown-option-multi-select>
  </ng-template>
</ng-select>
